/**
 * Atajos del Inicio agrupados por Planifica / Ejecuta / Mide.
 * Visibilidad: getHomeCapabilities (permiso + flag).
 */

export const HOME_SHORTCUTS = [
  {
    id: 'clientes',
    label: 'Clientes',
    href: '/clientes',
    icon: 'storefront',
    capability: 'clientes',
    pillar: 'planifica',
    description: 'Cartera y solicitudes'
  },
  {
    id: 'productos',
    label: 'Productos',
    href: '/productos',
    icon: 'package',
    capability: 'productos',
    pillar: 'planifica',
    description: 'Catálogo del tenant'
  },
  {
    id: 'usuarios',
    label: 'Usuarios',
    href: '/usuarios',
    icon: 'users',
    capability: 'usuarios',
    pillar: 'planifica',
    description: 'Equipo a tu cargo'
  },
  {
    id: 'plan_visitas',
    label: 'Plan de visitas',
    href: '/plan_de_visitas',
    icon: 'calendar',
    capability: 'planVisitas',
    pillar: 'planifica',
    description: 'Rutas del equipo'
  },
  {
    id: 'pedidos',
    label: 'Pedidos',
    href: '/pedidos',
    icon: 'cart',
    capability: 'pedidos',
    pillar: 'ejecuta',
    description: 'Ventas del equipo'
  },
  {
    id: 'devoluciones',
    label: 'Devoluciones',
    href: '/devoluciones',
    icon: 'uturn',
    capability: 'devoluciones',
    pillar: 'ejecuta',
    description: 'Cola de aprobación',
    alwaysShowForDesign: true
  },
  {
    id: 'cobros',
    label: 'Cobros',
    href: '/cobros',
    icon: 'coin',
    capability: 'cobros',
    pillar: 'ejecuta',
    description: 'Cobros del equipo'
  },
  {
    id: 'entregas',
    label: 'Entregas',
    href: '/entregas',
    icon: 'truck',
    capability: 'entregas',
    pillar: 'ejecuta',
    description: 'Entregas del equipo'
  },
  {
    id: 'liquidaciones',
    label: 'Liquidaciones',
    href: '/liquidaciones',
    icon: 'currency',
    capability: 'liquidaciones',
    pillar: 'ejecuta',
    description: 'Cierre de tus usuarios'
  },
  {
    id: 'activos',
    label: 'Activos',
    href: '/reporte_activos',
    icon: 'archive',
    capability: 'activos',
    pillar: 'ejecuta',
    description: 'Reporte y cierre',
    alwaysShowForDesign: true
  },
  {
    id: 'ordenes_oc',
    label: 'Órdenes OC',
    href: '/ordenes_oc',
    icon: 'clipboard',
    capability: 'ordenesOc',
    pillar: 'ejecuta',
    description: 'Órdenes de compra',
    alwaysShowForDesign: true
  },
  {
    id: 'venta_a_bordo',
    label: 'Venta a bordo',
    href: '/ventas_a_bordo',
    icon: 'truck',
    capability: 'ventaABordo',
    pillar: 'ejecuta',
    description: 'Ventas del camión',
    alwaysShowForDesign: true
  },
  {
    id: 'reportes',
    label: 'Reportes',
    href: '/reportes',
    icon: 'chartbar',
    capability: 'reportes',
    pillar: 'mide',
    description: 'Resultados de tus usuarios'
  },
  {
    id: 'fill_rate',
    label: 'Fill Rate',
    href: '/metricas_gerencia',
    icon: 'chartline',
    capability: 'fillRate',
    pillar: 'mide',
    description: 'Métricas por cadena'
  }
]

export const SHORTCUT_PILLARS = [
  { id: 'planifica', label: 'Planifica' },
  { id: 'ejecuta', label: 'Ejecuta' },
  { id: 'mide', label: 'Mide' }
]

export function getHomeShortcuts(capabilities, { showAllForDesign = false } = {}) {
  if (showAllForDesign) return HOME_SHORTCUTS
  if (!capabilities) return []
  return HOME_SHORTCUTS.filter((item) => Boolean(capabilities[item.capability]))
}

export function getShortcutsByPillar(capabilities, options) {
  const items = getHomeShortcuts(capabilities, options)
  return groupShortcutsByPillar(items)
}

export function groupShortcutsByPillar(items, pillarIds = null) {
  const allowed = pillarIds ? new Set(pillarIds) : null
  return SHORTCUT_PILLARS.filter((pillar) => !allowed || allowed.has(pillar.id))
    .map((pillar) => ({
      ...pillar,
      items: items.filter((item) => item.pillar === pillar.id)
    }))
    .filter((group) => group.items.length > 0)
}

/**
 * Casos quemados para diseño: todos, solo Planifica+Mide, solo Ejecuta.
 * Cada caso es un solo grid plano (sin columnas por pilar).
 */
export function getShortcutDesignCases() {
  const all = HOME_SHORTCUTS

  return [
    {
      id: 'all-pillars',
      title: 'Atajos',
      caseLabel: 'Caso A · Todos',
      subheader: 'Según tu rol y el tenant',
      items: all
    },
    {
      id: 'planifica-mide',
      title: 'Atajos',
      caseLabel: 'Caso B · Solo Planifica y Mide',
      subheader: 'Sin Ejecuta — configuración + reportes',
      items: all.filter((item) => item.pillar === 'planifica' || item.pillar === 'mide')
    },
    {
      id: 'solo-ejecuta',
      title: 'Atajos',
      caseLabel: 'Caso C · Solo Ejecuta',
      subheader: 'Sin Planifica ni Mide — operación del día',
      items: all.filter((item) => item.pillar === 'ejecuta')
    }
  ]
}

export function iconForNotificationCategory(category) {
  switch (category) {
    case 'liquidaciones':
      return 'account_balance_wallet'
    case 'reportes':
      return 'analytics'
    case 'pedidos':
      return 'shopping_cart'
    case 'devoluciones':
      return 'replay'
    case 'planifica':
      return 'event_note'
    case 'producto':
      return 'tips_and_updates'
    default:
      return 'notifications'
  }
}
